// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e83f0b6f","732":"4f75777e","977":"22522cc0"}[chunkId] + ".chunk.js";
};